import './index.css'

import { getEnvVariable } from '@/env'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { createHead } from '@unhead/vue/client'
import dayjs from 'dayjs'
import timezonePlugin from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { LDPlugin } from 'launchdarkly-vue-client-sdk'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import { customerioPlugin } from './plugins/customerio'
import flagSmithPlugin from './plugins/flagsmith'
import { segmentPlugin } from './plugins/segment'
import sentryPlugin from './plugins/sentry'
import { queryClient } from './queries/queryClient'
import { router } from './router'

dayjs.extend(utc)
// Needed for dog DOB age math (fixed IANA zone in add-dog-review-plan). Order display dates
// come from EnrichedOrder as calendar-day / precomputed fields — do not .tz() those.
dayjs.extend(timezonePlugin)

const pinia = createPinia()
const head = createHead()

const app = createApp(App)
  .use(flagSmithPlugin)
  .use(VueQueryPlugin, { queryClient })
  .use(router)
  .use(LDPlugin, { clientSideID: import.meta.env.VITE_LD_CLIENT_SIDE_ID, deferInitialization: true })
  .use(customerioPlugin, { writeKey: getEnvVariable('customerio_write_key') })
  .use(segmentPlugin, { writeKey: getEnvVariable('segment_write_key') })
  .use(sentryPlugin)
  .use(pinia)
  .use(head)

app.mount('#app')
